'use strict';
module.exports = function(app) {
    app.filter('lang', function ($rootScope) {
        return function (input) {
            if (input) {
                if ($rootScope.lang) {
                    return input[$rootScope.lang];
                } else {
                    return input["fi"];
                }
            }
        };
    });
};



/*****************
 ** WEBPACK FOOTER
 ** ./shared/js/filter/language.filter.js
 ** module id = 84
 ** module chunks = 0
 **/